var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductHeader',{attrs:{"header":"รายละเอียดข้อมูลสินค้า","img_header":_vm.header_image,"link_back":_vm.$store.state.link_url}}),_c('Product_details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }